/*
 * SEVESHOP FAVORITE — lista de favorite (faza 1: salvată în browser).
 *
 * Format listă (localStorage 'seveshop:favorite:v1'), cel mai nou primul:
 *   [{ h: handle, id: productId, p: preț la salvare (bani), t: timestamp }]
 *
 * Butoane:   [data-fav-toggle][data-fav-handle][data-fav-id][data-fav-price]  (snippets/fav-button.liquid)
 * Contoare:  [data-fav-count]  (header)
 * Eveniment: 'seveshop:favorite:change' pe document, detail = { list, handle, added }
 * API:       window.SeveFavorite.{ list(), has(h), add(item), remove(h), rename(old, new), count() }
 *
 * Client logat (faza 2): lista se sincronizează cu metafield-ul clientului prin app proxy-ul
 * /apps/favorite (aplicația „seveshop-cont" → Cloudflare Worker). Aceeași listă apare în contul clientului.
 *   - prima logare pe un browser: lista de vizitator se unește cu cea din cont
 *   - apoi contul e sursa de adevăr; modificările locale netrimise (flag „dirty") câștigă
 *   - la delogare lista locală a clientului se golește (browser partajat)
 *
 * Statistici: la fiecare schimbare, lista COMPLETĂ (doar ID-uri de produs) pleacă la /apps/favorite/track,
 * cu un ID anonim de browser ('seveshop:favorite:device'); clientul logat e identificat de Shopify.
 * Worker-ul numără browsere/clienți distincți per produs → metafield custom.favorite_count.
 * Plus evenimentele __sm__add_to_wishlist / __sm__remove_from_wishlist pentru theMarketer.
 */
(function () {
  if (window.SeveFavorite) return;

  var KEY = 'seveshop:favorite:v1';
  var MAX = 100;
  var PAGE_URL = (window.SeveFavoriteConfig && window.SeveFavoriteConfig.pageUrl) || '/pages/favorite';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (i) { return i && typeof i.h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write() {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    schedulePush();
    scheduleTrack();
  }

  /* ---------- sincronizare cont ---------- */

  var CFG = window.SeveFavoriteConfig || {};
  var CUSTOMER = CFG.customerId ? String(CFG.customerId) : null;
  var PROXY = CFG.proxyUrl || '/apps/favorite';
  var OWNER_KEY = 'seveshop:favorite:owner';
  var DIRTY_KEY = 'seveshop:favorite:dirty';
  var syncReady = !CUSTOMER;
  var pushTimer;

  function lsGet(k) {
    try { return localStorage.getItem(k); } catch (e) { return null; }
  }
  function lsSet(k, v) {
    try {
      if (v === null) localStorage.removeItem(k);
      else localStorage.setItem(k, v);
    } catch (e) {}
  }

  function schedulePush() {
    if (!CUSTOMER) return;
    lsSet(DIRTY_KEY, '1');
    if (!syncReady) return; // sincronizarea inițială decide ce trimitem
    clearTimeout(pushTimer);
    pushTimer = setTimeout(push, 400);
  }

  function push() {
    return fetch(PROXY, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ list: list })
    })
      .then(function (r) { if (r.ok) lsSet(DIRTY_KEY, null); })
      .catch(function () {});
  }

  function replaceList(next) {
    list = next.slice(0, MAX);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    paint();
    emit(null, null);
    scheduleTrack();
  }

  /* ---------- statistici ---------- */

  var DEVICE_KEY = 'seveshop:favorite:device';
  var TRACKED_KEY = 'seveshop:favorite:tracked'; // semnătura ultimei liste trimise
  var trackTimer;

  function deviceId() {
    var d = lsGet(DEVICE_KEY);
    if (!d || !/^[a-z0-9-]{16,64}$/.test(d)) {
      d = window.crypto && crypto.randomUUID
        ? crypto.randomUUID()
        : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
      lsSet(DEVICE_KEY, d);
    }
    return d;
  }

  function scheduleTrack() {
    if (CUSTOMER && !syncReady) return; // clientul logat: trimitem lista contului, după sincronizare
    clearTimeout(trackTimer);
    trackTimer = setTimeout(track, 1500);
  }

  // Trimitem doar când lista diferă de ultima trimisă (o listă nesalvată încă pe server pleacă la următoarea pagină).
  function track() {
    var sig = (CUSTOMER || '') + ':' + list.map(function (i) { return i.id; }).sort().join(',');
    var last = lsGet(TRACKED_KEY);
    if (last === sig || (last === null && !list.length)) return;
    fetch(PROXY + '/track', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        device: deviceId(),
        items: list.map(function (i) { return { id: i.id, h: i.h, t: i.t }; })
      })
    })
      .then(function (r) { if (r.ok) lsSet(TRACKED_KEY, sig); })
      .catch(function () {});
  }

  function announce(item, added) {
    if (!item || !item.id) return;
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: added ? '__sm__add_to_wishlist' : '__sm__remove_from_wishlist', product_id: String(item.id), variation: false });
      }
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(added ? 'add_to_wishlist' : 'remove_from_wishlist', { productId: String(item.id), handle: item.h });
      }
    } catch (e) {}
  }

  function union(a, b) {
    var seen = {}, out = [];
    a.concat(b).forEach(function (i) {
      if (i && i.h && !seen[i.h]) { seen[i.h] = true; out.push(i); }
    });
    out.sort(function (x, y) { return (y.t || 0) - (x.t || 0); });
    return out.slice(0, MAX);
  }

  function initialSync() {
    if (!CUSTOMER) {
      // delogat pe un browser pe care fusese un client: nu-i lăsăm lista la vedere
      if (lsGet(OWNER_KEY)) {
        lsSet(OWNER_KEY, null);
        lsSet(DIRTY_KEY, null);
        replaceList([]);
      }
      return;
    }
    fetch(PROXY, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (res) {
        if (!res || !res.loggedIn) return;
        var remote = Array.isArray(res.list) ? res.list : [];
        var owner = lsGet(OWNER_KEY);
        var next;
        if (owner !== CUSTOMER) next = owner ? remote : union(remote, list);
        else if (lsGet(DIRTY_KEY)) next = list;
        else next = remote;
        lsSet(OWNER_KEY, CUSTOMER);
        var changed = JSON.stringify(next) !== JSON.stringify(remote);
        replaceList(next);
        if (changed) push();
        else lsSet(DIRTY_KEY, null);
      })
      .catch(function () {})
      .then(function () {
        syncReady = true;
        scheduleTrack();
      });
  }

  var list = read();

  function indexOf(handle) {
    for (var i = 0; i < list.length; i++) if (list[i].h === handle) return i;
    return -1;
  }

  function has(handle) {
    return indexOf(handle) > -1;
  }

  function emit(handle, added) {
    document.dispatchEvent(
      new CustomEvent('seveshop:favorite:change', { detail: { list: list.slice(), handle: handle, added: added } })
    );
  }

  function add(item) {
    if (!item || !item.h || has(item.h)) return;
    list.unshift({ h: item.h, id: Number(item.id) || 0, p: Number(item.p) || 0, t: Date.now() });
    if (list.length > MAX) list.length = MAX;
    write();
    paint();
    emit(item.h, true);
    announce(list[0], true);
  }

  function remove(handle) {
    var i = indexOf(handle);
    if (i < 0) return;
    var gone = list.splice(i, 1)[0];
    write();
    paint();
    emit(handle, false);
    announce(gone, false);
  }

  // Handle schimbat (redirect 301 în admin): păstrăm prețul și data salvării, mutăm pe noul handle.
  function rename(oldHandle, newHandle) {
    var i = indexOf(oldHandle);
    if (i < 0 || !newHandle || oldHandle === newHandle) return;
    if (has(newHandle)) list.splice(i, 1);
    else list[i].h = newHandle;
    write();
    paint();
  }

  /* ---------- UI ---------- */

  function paint() {
    var buttons = document.querySelectorAll('[data-fav-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = has(b.getAttribute('data-fav-handle'));
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      var label = on ? 'Elimină din favorite' : 'Adaugă la favorite';
      if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
    }
    var counters = document.querySelectorAll('[data-fav-count]');
    for (var j = 0; j < counters.length; j++) {
      var c = counters[j];
      // doar la diferență: textContent înlocuiește nodul text → ar re-declanșa MutationObserver-ul
      if (c.textContent !== String(list.length)) c.textContent = list.length;
      if (c.hidden !== (list.length === 0)) c.hidden = list.length === 0;
    }
  }

  var toastEl, toastTimer;
  function toast(added) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sfav-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var txt = document.createElement('span');
    txt.textContent = added ? 'Adăugat la favorite' : 'Eliminat din favorite';
    toastEl.appendChild(txt);
    if (added && location.pathname !== PAGE_URL) {
      var a = document.createElement('a');
      a.href = PAGE_URL;
      a.textContent = 'Vezi lista';
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  function bump() {
    var counters = document.querySelectorAll('[data-fav-count]');
    for (var i = 0; i < counters.length; i++) {
      var c = counters[i];
      c.classList.remove('is-bump');
      void c.offsetWidth;
      c.classList.add('is-bump');
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-fav-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-fav-handle');
      if (has(handle)) {
        remove(handle);
        toast(false);
      } else {
        add({ h: handle, id: btn.getAttribute('data-fav-id'), p: btn.getAttribute('data-fav-price') });
        toast(true);
        bump();
      }
    },
    true
  );

  // Swiper / caruselul de pe card ascultă touch pe ancestori: inima nu trebuie să pornească un swipe.
  ['touchstart', 'pointerdown'].forEach(function (type) {
    document.addEventListener(
      type,
      function (e) {
        if (e.target.closest && e.target.closest('[data-fav-toggle]')) e.stopPropagation();
      },
      { capture: true, passive: true }
    );
  });

  // Sincron între taburi.
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    list = read();
    paint();
    emit(null, null);
  });

  // Cardurile apar și după load (filtre AJAX, recomandări, căutare): repictăm debounced.
  // PERF 14/10/2026: observer-ul pornește abia după `load` (până atunci app-urile inserează sute de noduri
  // și fiecare val declanșa un paint pe tot documentul) și repictează doar dacă printre nodurile noi
  // există o inimă sau un contor.
  var FAV_SEL = '[data-fav-toggle],[data-fav-count]';
  var pending = false;
  function schedulePaint() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      paint();
    });
  }
  function relevant(records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches(FAV_SEL) || n.querySelector(FAV_SEL))) return true;
      }
    }
    return false;
  }
  function startObserver() {
    paint();
    new MutationObserver(function (records) {
      if (!pending && relevant(records)) schedulePaint();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'complete') startObserver();
  else window.addEventListener('load', startObserver, { once: true });

  window.SeveFavorite = {
    list: function () { return list.slice(); },
    has: has,
    add: add,
    remove: remove,
    rename: rename,
    count: function () { return list.length; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
  initialSync();
  if (!CUSTOMER) setTimeout(track, 2500);
})();
